<template>
    <div>
        <test-template :testName="testName" :testId="testId" :test="test" :opposedAnswers="opposedAnswers" multidimensional>
            <template #questions>
                <question-card :question="cQ" v-model="questionResult" :progress="$store.state.tests.currentSlide" :questionnaireLength="$store.state.tests.test.length"  @answerQuestion="() => { $store.commit('tests/incrementSlide') }" @submitQuestionnaire="saveTestResults"></question-card>
            </template>
            <template #results>
                <div key="topGraph" class="first">
                    <h3 class="subtitle-card text-center">{{ $t('tests.testResults') }} - {{ testName.toUpperCase() }}</h3>
                    <column-chart :lastYearResults="$store.state.tests.previousTestResults.slice(-12)" :testName="testName"></column-chart>
                </div>
                <div key="recapCard" class="second">
                    <h4>{{ $t('tests.results') }} {{ month }}</h4>
                    <b-card class="neu-card mean-result col-lg-7">
                        <b-row class="h-100">
                            <b-col lg="5" class="align-self-center"><h3 class="subtitle-card"> {{ testName.toUpperCase() }}</h3></b-col>
                            <b-col lg="7" class="my-auto">
                                <gauge-chart :labels="[testName]" :result="DBResults.generalResult"></gauge-chart>
                            </b-col>
                        </b-row>
                    </b-card>
                </div>
                <div>
                    <b-row>
                        <b-col cols="12" md="6" class="p-2">
                            <b-card class="neu-card" :title="$t('tests.physical-health')">
                                <b-icon-circle-fill :style="`color: ${setColor(physicalHealthMeanResult)}`"></b-icon-circle-fill> <span>{{ physicalHealthMeanResult }}%</span>
                                <hr class="mt-2">
                                <b-row v-for="d in DBResults.dimensions.slice(0, 4)"  :key="d.name">
                                    <b-col class="text-left" cols="9"><strong v-html="$t(d.name)"></strong></b-col><b-col cols="3" class="align-self-center"><b-icon-circle-fill :style="`color: ${interpretationColor(d.name, d.result)}`"></b-icon-circle-fill> <span>{{ d.result }}%</span></b-col>
                                    <!-- <strong v-html="$t(d.name)"></strong>  <b-icon-circle-fill :style="`color: ${interpretationColor(d.name, d.result)}`"></b-icon-circle-fill> <span>{{ dimensionResult(d.name, d.points, d.totalDimensionPoints) }}</span> -->
                                </b-row>
                            </b-card>
                        </b-col>
                        <b-col cols="12" md="6" class="p-2">
                            <b-card class="neu-card" :title="$t('tests.mental-health')">
                                <b-icon-circle-fill :style="`color: ${setColor(mentalHealthMeanResult)}`"></b-icon-circle-fill> <span>{{ mentalHealthMeanResult }}%</span>
                                <hr class="mt-2">
                                <b-row v-for="d in DBResults.dimensions.slice(4, 8)" :key="d.name">
                                    <b-col class="text-left" cols="9"><strong v-html="$t(d.name)"></strong></b-col><b-col cols="3" class="align-self-center"><b-icon-circle-fill :style="`color: ${interpretationColor(d.name, d.result)}`"></b-icon-circle-fill> <span>{{ d.result }}%</span></b-col>
                                    <!-- <strong v-html="$t(d.name)"></strong>  <b-icon-circle-fill :style="`color: ${interpretationColor(d.name, d.result)}`"></b-icon-circle-fill> <span>{{ dimensionResult(d.name, d.points, d.totalDimensionPoints) }}</span> -->
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </template>
        </test-template>
    </div>
</template>

<script>
import TestTemplate from './TestTemplate.vue'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'
import { TEST_GENERAL_HEALTH } from '@/constants/patientServices'
import { GREEN_COLOUR, RED_COLOUR, YELLOW_COLOUR, GREEN_LIGHT_COLOUR, ORANGE_MID_COLOUR } from '@/constants/colours'

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        'test-template': TestTemplate,
        'gauge-chart': () => import('@/components/charts/GaugeChart.vue'),
        'column-chart': () => import('@/components/charts/ColumnChart.vue')
    },
    data () {
        const answers = {
            limitations: [
                {value: 100, text: this.$t('tests.answers.limitNone')},
                {value: 50, text: this.$t('tests.answers.limitABit')},
                {value: 0, text: this.$t('tests.answers.limitALot')}
            ],
            healthState: [
                {value: 0, text: this.$t('tests.answers.bad')},
                {value: 25, text: this.$t('tests.answers.regular')},
                {value: 50, text: this.$t('tests.answers.good')},
                {value: 75, text: this.$t('tests.answers.veryGood')},
                {value: 100, text: this.$t('tests.answers.excelent')}
            ],
            interference: [
                {value: 100, text: this.$t('tests.answers.no')},
                {value: 0, text: this.$t('tests.answers.yes')}
            ],
            healthStateMomentum: [
                {value: 0, text: this.$t('tests.answers.muchWorseNow')},
                {value: 25, text: this.$t('tests.answers.someWorseNow')},
                {value: 50, text: this.$t('tests.answers.moreOrLessTheSame')},
                {value: 75, text: this.$t('tests.answers.someBetterNow')},
                {value: 100, text: this.$t('tests.answers.muchBetterNow')}
            ],
            time: [
                {value: 0, text: this.$t('tests.answers.never')},
                {value: 20, text: this.$t('tests.answers.almostNever')},
                {value: 40, text: this.$t('tests.answers.sometimes')},
                {value: 60, text: this.$t('tests.answers.alot')},
                {value: 80, text: this.$t('tests.answers.alot2')},
                {value: 100, text: this.$t('tests.answers.always')}
            ],
            partialTime: [
                {value: 100, text: this.$t('tests.answers.never')},
                {value: 75, text: this.$t('tests.answers.almostNever')},
                {value: 50, text: this.$t('tests.answers.sometimes')},
                {value: 25, text: this.$t('tests.answers.alot2')},
                {value: 0, text: this.$t('tests.answers.always')}
            ],
            painInterference: [
                {value: 100, text: this.$t('tests.answers.nothingAtAll')},
                {value: 75, text: this.$t('tests.answers.veryLittle')},
                {value: 50, text: this.$t('tests.answers.moderately')},
                {value: 25, text: this.$t('tests.answers.prettyMuch')},
                {value: 0, text: this.$t('tests.answers.extremately')}
            ],
            agreementLevel: [
                {value: 0, text: this.$t('tests.answers.total-disagreement')},
                {value: 25, text: this.$t('tests.answers.disagreement')},
                {value: 50, text: this.$t('tests.answers.agreement-disagreement')},
                {value: 75, text: this.$t('tests.answers.agreement')},
                {value: 100, text: this.$t('tests.answers.total-agreement')}
            ],
            pain: [
                {value: 100, text: this.$t('tests.answers.noneMasculine')},
                {value: 80, text: this.$t('tests.answers.verySlight')},
                {value: 60, text: this.$t('tests.answers.slight')},
                {value: 40, text: this.$t('tests.answers.moderate')},
                {value: 20, text: this.$t('tests.answers.severe')},
                {value: 0, text: this.$t('tests.answers.verySevere')}
            ]
        }

        const test = [
            {
                dimension: 'tests.general-health.dimensions.physical-function',
                qs: ['q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10', 'q11', 'q12']
            },
            {
                dimension: 'tests.general-health.dimensions.physical-limitations',
                qs: ['q13', 'q14', 'q15', 'q16'],
                opposedDirection: true
            },
            {
                dimension: 'tests.general-health.dimensions.body-pain',
                qs: ['q21', 'q22'],
                opposedDirection: true
            },
            {
                dimension: 'tests.general-health.dimensions.general-health',
                qs: ['q1', 'q2', 'q33', 'q34', 'q35', 'q36']
            },
            {
                dimension: 'tests.general-health.dimensions.vitality',
                qs: ['q23', 'q27', 'q29', 'q31']
            },
            {
                dimension: 'tests.general-health.dimensions.social-function',
                qs: ['q20', 'q32']
            },
            {
                dimension: 'tests.general-health.dimensions.emotional-limitations',
                qs: ['q17', 'q18', 'q19'],
                opposedDirection: true
            },
            {
                dimension: 'tests.general-health.dimensions.mental-health',
                qs: ['q24', 'q25', 'q26', 'q28', 'q30']
            }
        ]

        const opposedAnswers = ['q24', 'q25', 'q28', 'q29', 'q31', 'q33', 'q35']

        return {
            test: test,
            testId: TEST_GENERAL_HEALTH,
            opposedAnswers: opposedAnswers,
            testName: this.$t('tests.general-health.title'),
            multidimensional: true,
            answers: answers
        }
    },
    created () {
        this.createQuestions()
    },
    methods: {
        createQuestions () {
            var dimIndex = 1
            this.test.map(dimension => {
                dimension.id = `apartado-${dimIndex}`
                var questions = []
                dimension.qs.map(qx => questions.push({
                    id: qx,
                    question: this.$t(`tests.general-health.questions.${qx}`),
                    answer: this.setQuestionAnswer(qx),
                    result: null
                }))
                dimIndex = dimIndex + 1
                this.$set(dimension, 'questions', questions)
            })
        },
        setQuestionAnswer (question) {
            switch (true) {
                case question === 'q1':
                    return this.answers.healthState
                case question === 'q2':
                    return this.answers.healthStateMomentum
                case ['q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10', 'q11', 'q12'].includes(question):
                    return this.answers.limitations
                case ['q13', 'q14', 'q15', 'q16', 'q17', 'q18', 'q19'].includes(question):
                    return this.answers.interference
                case ['q23', 'q24', 'q25', 'q26', 'q27', 'q28', 'q29', 'q30', 'q31'].includes(question):
                    return this.answers.time
                case ['q20', 'q22'].includes(question):
                    return this.answers.painInterference
                case question === 'q21':
                    return this.answers.pain
                case question === 'q32':
                    return this.answers.partialTime
                case ['q33', 'q34', 'q35', 'q36'].includes(question):
                    return this.answers.agreementLevel
            }
        },
        saveTestResults () {
            var dimensions = []
            for (let dimension of this.test) {
                var dimensionValues = this.calculateMultidimensionalDimPoints(dimension)
                var percentage = Math.round(dimensionValues.sum / dimension.questions.length)
                var result = dimension.opposedDirection ? 100 - percentage : percentage
                dimensions.push({'result': result, 'id': dimension.id, 'name': dimension.dimension, 'points': dimensionValues.sum, 'totalDimensionPoints': dimensionValues.total})
            }
            this.save(dimensions, Math.round(dimensions.map(x => x.points).reduce((x, y) => x + y, 0) / 36))
        },
        interpretationColor (dimensionName, r) {
            const dimension = this.test.find(item => item.dimension === dimensionName)
            return this.setColor(r, dimension.opposedDirection)
        },
        setColor (r, opposedDirection = false) {
            if (opposedDirection) r = 100 - r
            return r >= 85 ? GREEN_COLOUR : r >= 70 ? GREEN_LIGHT_COLOUR : r >= 50 ? YELLOW_COLOUR : r >= 35 ? ORANGE_MID_COLOUR : RED_COLOUR
        },
        dimensionResult (dimensionName, points, dimensionPoints) {
            const dimension = this.test.find(item => item.dimension === dimensionName)
            if (dimension.opposedDirection || false) {
                points = dimensionPoints - points
            }
            return `${points}/${dimensionPoints}`
        }
    },
    computed: {
        physicalHealthMeanResult () {
            return Math.round(this.DBResults.dimensions.slice(0, 4).map(x => Math.round(x.points * 100 / x.totalDimensionPoints)).reduce((x, y) => x + y, 0) / 4)
        },
        mentalHealthMeanResult () {
            return Math.round(this.DBResults.dimensions.slice(4, 8).map(x => Math.round(x.points * 100 / x.totalDimensionPoints)).reduce((x, y) => x + y, 0) / 4)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/GeneralHealthTest.vue